import codes from "../../errorCodes/tenantMetadata";
export default function (code) {
    switch (code) {
        case codes.RequestBodyInvalid:
            return "errors.customisation.RequestBodyInvalid";
        default:
            return "";
    }
}
